import React, { useContext, useDebugValue, useEffect, useState } from 'react'
import './Result.css'
import { motion } from 'framer-motion'
import Correct from "../../imgs/correct.png";
import Incorrect from "../../imgs/incorrect.png";
import Unanswered from "../../imgs/unanswered.png";
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import {
    CircularProgressbarWithChildren,
    buildStyles
} from "react-circular-progressbar";
import { fontSize } from '@mui/system';
import Globalcontext from '../../Context/Globalcontext';
import { useLocation, useNavigate } from 'react-router-dom';


const Result = (props) => {
    const { state } = useLocation();
    const a = useContext(Globalcontext);
    const navigate = useNavigate();
    const [DataSource, setDataSource] = useState([]);
    const prcent1 = 0.0;
    const attquestions = 20 - state.anasweredtemp1;

    const handlesolutions = () => {
        a.setexamtype(state.testname);
        a.setSolutionflag("true");
        a.setIndex(0);
        a.setCorrect(0);
        a.setAnasweredtemp(0);

        a.settempunanswer(state.anasweredtemp1);
        if (state.testname === "Main Test" || state.testname === "Demo Test") {

            let tempresult = "";
          
            if (localStorage.getItem("glresult") !== "null") {
                tempresult = JSON.parse(localStorage.getItem("glresult"));
                
            }
            else {
                tempresult = a.mainresult;
            }
            if (tempresult !== "null") {
                setDataSource(tempresult);
                if (tempresult !== "null") {
                    let rawData = {
                        grade1: state.grade,
                        language1: state.language,
                        testname: state.testname,
                        DataSource: tempresult,
                    }

                  //  console.log(JSON.parse(localStorage.getItem("glresult")));
                    navigate('/exam', { state: rawData });
                }
            }
        }
        else if (state.testname === "Practice Test") {
            navigate(-1);
        }
    }

    useEffect(() => {

    }, [DataSource])


    var jsEncode = {
        encode: function (s, k) {
            var enc = "";
            var str = "";
            // make sure that input is string
            str = s.toString();
            for (var i = 0; i < s.length; i++) {
                // create block
                var a = s.charCodeAt(i);
                // bitwise XOR
                var b = a ^ k;
                enc = enc + String.fromCharCode(b);
            }
            return enc;
        }
    };

    useEffect(() => {
        if (localStorage.getItem("gllogin") === '') {
            navigate('/studentiqtest');
        }
    })

    const handleEnd = () => {
        a.setStatus("ended");
        a.setSeconds(59);
        a.setMinutes(29);
        a.setIndex(0);
        a.setCorrect(0);
        a.setAnasweredtemp(0);
        a.setElminutes(0);
        a.setElseconds(0);
        a.setSolutionflag("false");
        setempty();

       
    }

    const setempty = () => {
        a.setq1array({ "option": '', "correct": '' });
        a.setq2array({ "option": '', "correct": '' });
        a.setq3array({ "option": '', "correct": '' });
        a.setq4array({ "option": '', "correct": '' });
        a.setq5array({ "option": '', "correct": '' });
        a.setq6array({ "option": '', "correct": '' });
        a.setq7array({ "option": '', "correct": '' });
        a.setq8array({ "option": '', "correct": '' });
        a.setq9array({ "option": '', "correct": '' });
        a.setq10array({ "option": '', "correct": '' });
        a.setq11array({ "option": '', "correct": '' });
        a.setq12array({ "option": '', "correct": '' });
        a.setq13array({ "option": '', "correct": '' });
        a.setq14array({ "option": '', "correct": '' });
        a.setq15array({ "option": '', "correct": '' });
        a.setq16array({ "option": '', "correct": '' });
        a.setq17array({ "option": '', "correct": '' });
        a.setq18array({ "option": '', "correct": '' });
        a.setq19array({ "option": '', "correct": '' });
        a.setq20array({ "option": '', "correct": '' });

        a.setq1('');
        a.setq2('');
        a.setq3('');
        a.setq4('');
        a.setq5('');
        a.setq6('');
        a.setq7('');
        a.setq8('');
        a.setq9('');
        a.setq10('');
        a.setq11('');
        a.setq12('');
        a.setq13('');
        a.setq14('');
        a.setq15('');
        a.setq16('');
        a.setq17('');
        a.setq18('');
        a.setq19('');
        a.setq20('');

        localStorage.setItem('glresult', "");
        localStorage.setItem('gletime',"");
        localStorage.setItem('glrand',"");
        localStorage.setItem('glmaintest', "");
    
        navigate('/Dashboard');
    }

    return (
        <div className='result'>
            <div className="whiteboxresult">
                <div className="title">
                    <div className="title1">
                        <span>{state.testname}</span>
                        <span className='head'>Result analysis : {state.ayear ? state.ayear : ""}</span>
                    </div>
                    <div className="title2">
                        <button onClick={handlesolutions} >View Solutions</button>
                        <button onClick={handleEnd} >Homepage</button>
                    </div>
                </div>
                <div style={{ marginTop: "10px" }} className='line' />

                <div className="toprowresult">
                    <div className="firstpart">
                        <span className='maintitle'>Score</span>
                        <div className="score">
                            <CircularProgressbar
                                styles={buildStyles({
                                    textColor: "red",
                                    pathColor: "#FF9800",
                                    trailColor: "#D3D3D8",
                                    fontSize: "9px"
                                })}
                                className='scoregraff' value={(state.correct1 / 20) * 100} text={state.correct1 + " / 20"} />
                            <div className="scoredetails">
                                <div className="scorerow">
                                    <img src={Correct} alt="" />
                                    <span>{state.correct1} Correct</span>
                                </div>
                                <div className='line' />
                                <div className="scorerow">
                                    <img src={Incorrect} alt="" />
                                    <span>{20 - (state.anasweredtemp1 + state.correct1)} Incorrect</span>
                                </div>
                                <div className='line' />
                                <div className="scorerow">
                                    <img src={Unanswered} alt="" />
                                    <span>{state.anasweredtemp1} Unanswered</span>
                                </div>
                                <div className='line' />
                            </div>
                        </div>
                    </div>
                    <div className="secondpart">
                        {(state.testname === "Demo Test" || state.testname === "Practice Test") ?
                            <span className='maintitle'>Estimated IQ Score</span>
                            :
                            ''
                        }
                        {(state.testname === "Demo Test" || state.testname === "Practice Test") ?
                            <div className="secondbody">
                                <div className="scoredetails">
                                    <div className="scorerow">
                                        <img src={Correct} alt="" />
                                        <span>Your Estimated IQ Score is more than {a.estiscore}</span>
                                    </div>
                                </div>
                            </div>
                            : ''
                        }

                    </div>
                </div>
                <div className='line' />
                <div className="toprowresult">
                    <div className="bottomfirst">
                        <span className='maintitle'>Time Elapsed</span>
                        <div className="timerow">
                            <div className="timecolumn">
                                <CircularProgressbar
                                    styles={buildStyles({
                                        textColor: "red",
                                        pathColor: "red",
                                        trailColor: "#D3D3D8",
                                        fontSize: "9px"
                                    })}
                                    className='timegraff' value={a.seconds} text={a.elminutes + " Min : " + (60 - a.seconds) + " Sec"} />
                                <span>Minutes</span>
                            </div>
                            <div className="timecolumn">
                                <CircularProgressbar
                                    styles={buildStyles({
                                        textColor: "red",
                                        pathColor: "red",
                                        trailColor: "#D3D3D8",
                                        fontSize: "9px"
                                    })}
                                    className='timegraff' value={a.seconds} text={(60 - a.seconds) + (a.elminutes * 60)} />
                                <span>Seconds</span>
                            </div>
                            <div className="timecolumn">
                                <CircularProgressbar
                                    styles={buildStyles({
                                        textColor: "red",
                                        pathColor: "red",
                                        trailColor: "#D3D3D8",
                                        fontSize: "9px"
                                    })}
                                    className='timegraff' value={a.seconds} text={(((60 - a.seconds) + (a.elminutes * 60)) * 1000) + Math.round(state.rand)} />
                                <span>Milliseconds</span>
                            </div>

                        </div>
                    </div>

                    <div className="bottomsecond">
                        <span className='maintitle'>Stats</span>
                        <div className="timerow">
                            <div className="timecolumn">
                                <CircularProgressbar
                                    styles={buildStyles({
                                        textColor: "red",
                                        pathColor: "#A44CB3",
                                        trailColor: "#D3D3D8",
                                        fontSize: "9px"
                                    })}
                                    className='timegraff' value={Math.round((state.correct1 / 20) * 100)} text={Math.round((state.correct1 / 20) * 100) + "%"} />
                                <span>Accuracy</span>
                            </div>
                            <div className="timecolumn">
                                <CircularProgressbar
                                    styles={buildStyles({
                                        textColor: "red",
                                        pathColor: "#4AE100",
                                        trailColor: "#D3D3D8",
                                        fontSize: "9px"
                                    })}
                                    className='timegraff' value={((60 - a.seconds) + (a.elminutes * 60)) / attquestions} text={Math.round(((60 - a.seconds) + (a.elminutes * 60)) / attquestions) + " Sec"} />
                                <span>Avg Speed/Que</span>
                            </div>


                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Result
